define('searchJSON',['jquery', 'handlebars'], function ($) {
    $.fn.extend({
        SearchResult: function (searchFilterContainer, options) {

            var option = new Object();
            option.DataPath = options.datapath;
            option.Template = options.template;
            option.Container = $(this);
            var $resourceList = $(".resource-list");
            var $filterItems = searchFilterContainer.find("input, select");

            var datacollection;
            var resourcesIsFetched = false;
            var fetchAndShowMore = false;

            var fetchingClass = "fetching",
                fetchedClass = "fetched";

            // init json feed
            // $.get(option.DataPath, function (data) {
            $.get(option.DataPath, function (data) {
                datacollection = data;

                var debounceKeyInput = debounce(function() {
                    filterResources();
                }, 250);

                // Triggers
                searchFilterContainer.find("input[type=text]").keyup(debounceKeyInput);

                searchFilterContainer.find("select").change(function () {
                    filterResources();
                });

                searchFilterContainer.find("input[type=checkbox]").click(function () {
                    filterResources();
                });

                //On page init
                searchResult(searchFilterGroups(searchFilterElms()));

                // If on resource page, show the 'show more' button and add event handler to it
                if ($resourceList.length) {
                    var $showMoreBtn = $resourceList.find(".show-more");
                    $showMoreBtn.removeClass("hidden");
                    $showMoreBtn.click(function(event) {
                        event.preventDefault();
                        if (!resourcesIsFetched) {
                            fetchAndShowMore = true;
                            filterResources();
                        } else {
                            // Since we do not want to fetch more resources, we trigger event that masonryLayout handles
                            triggerEvent("show_more");
                        }
                    });
                }

                // Returns a function, that, as long as it continues to be invoked, will not
                // be triggered. The function will be called after it stops being called for
                // N milliseconds. If `immediate` is passed, trigger the function on the
                // leading edge, instead of the trailing.
                function debounce(func, wait, immediate) {
                    var timeout;
                    return function() {
                        var context = this, args = arguments;
                        var later = function() {
                            timeout = null;
                            if (!immediate) func.apply(context, args);
                        };
                        var callNow = immediate && !timeout;
                        clearTimeout(timeout);
                        timeout = setTimeout(later, wait);
                        if (callNow) func.apply(context, args);
                    };
                };
            }, "json");

            // filter the resources, but if on resource page and not all resources are fetched, show a waiting state, while resources loads
            var filterResources = function() {
                if ($resourceList.length && !resourcesIsFetched) {
                    $filterItems.attr("disabled", true);
                    searchFilterContainer.addClass("disabled");
                    $resourceList.addClass(fetchingClass);
                } else {
                    //console.log("searchFilterGroups(searchFilterElms())", searchFilterGroups(searchFilterElms()))
                    searchResult(searchFilterGroups(searchFilterElms()));
                }
            };

            var getAllResources = function() {
                $.get(option.DataPath + "all", function (data) {
                    resourcesIsFetched = true;

                    // Update datacollection to represent all the data
                    datacollection = data;

                    // Remove the waiting state the user is shown, and reenable filters
                    $resourceList.removeClass(fetchingClass);
                    $resourceList.addClass(fetchedClass);
                    $filterItems.attr("disabled", false);
                    searchFilterContainer.removeClass("disabled");

                    // layout items with filters applied - if any
                    searchResult(searchFilterGroups(searchFilterElms()));
                }, "json");
            };

            var searchResult = function (groupfilter, s) {
                var mapping;
                if (groupfilter.length == 0) {
                    outputSearhResult(datacollection);
                }
                else {
                    mapping = $.grep(datacollection, function (obj, idx) {
                        var returnMapping = true;
                        $.each(groupfilter, function (idxGroup, currGroup) {
                            var temp = false;
                            $.each(groupfilter[currGroup], function (idx, currFilter) {

                                if (currFilter.val() != "" && currFilter.val() != undefined && currGroup != undefined) {
                                    if (IsNested(currGroup) != -1) {
                                        var a = currGroup.split('|')[0];
                                        var b = currGroup.split('|')[1];
                                        $.each(obj[a], function (idxchild, currFilterchild) {

                                            if (currFilter.is("select")) {
                                                if (currFilterchild[b].toLowerCase() == currFilter.val().toLowerCase()) {
                                                    temp = temp || obj;
                                                };
                                            } else {
                                                if (currFilterchild[b].toLowerCase().indexOf(currFilter.val().toLowerCase()) != -1) {
                                                    temp = temp || obj;
                                                };
                                            }
                                        });
                                    }else if (currFilter.val() == "Video & webinar"){
                                        temp = temp || obj[currGroup].toLowerCase() == "video" || obj[currGroup].toLowerCase() == "webinar";
                                    }else {

                                        if (currFilter.is("select")) {
                                            temp = temp || obj[currGroup].toLowerCase() == currFilter.val().toLowerCase();
                                        } else {
                                            temp = temp || obj[currGroup].toLowerCase().indexOf(currFilter.val().toLowerCase()) != -1;
                                        }

                                    }
                                }
                            });
                            returnMapping = returnMapping && temp;
                        });
                        return returnMapping;
                    }, false);
                    outputSearhResult(mapping);
                }
            };
            var IsNested = function (key) {
                return key.indexOf('|');
            };
            var searchFilterElms = function () {
                var s = searchFilterContainer.find("input:checked, select option:selected");
                var t = searchFilterContainer.find("input[type=text]");
                $.each(t, function (idx, obj) {
                    var $obj = $(obj);
                    if ($obj.val() != $obj.attr("placeholder")) {
                        s.push(obj);
                    }
                });
                return s;
            };
            var searchFilterGroups = function (filter) {
                var groups = [];
                filter.each(function () {
                    curElm = $(this);
                    currFilterElm = $(this).attr("name");
                    if (currFilterElm == "" || currFilterElm == undefined || currFilterElm == null) {
                        currFilterElm = $(this).parent().attr("name");
                        curElm = $(this).parent();
                    }
                    if ($(this).val() != "") {
                        if (groups[currFilterElm] == undefined) {
                            groups.push(currFilterElm);
                            groups[currFilterElm] = [];
                            groups[currFilterElm].push(curElm);
                        } else {
                            groups[currFilterElm].push(curElm);
                        }
                    }
                });
                return groups;
            };
            var triggerEvent = function (e) {
                $(document).trigger(e, true);
            };
            var outputSearhResult = function (mapping) {
                var html = "";
                var succes = false;
                if (mapping.length > 0) {
                    var source = $("#template").html();
                    var template = Handlebars.compile(source);
                    html = template(mapping);
                    succes = true;
                } else {
                    if (options.noResultHtml.length > 0) {
                        html = options.noResultHtml.show().wrap("<div>").parent().html();
                    }

                }
                option.Container.html(html);

                if (succes) {
                    // Get all resources after the initial few has been fetched
                    if (!resourcesIsFetched && $resourceList.length) {
                        getAllResources();
                    }
                    if (fetchAndShowMore) {
                        fetchAndShowMore = false;
                        triggerEvent("fetch_show_more");
                    } else {
                        $filterItems.attr("disabled", false); // Make sure filters are usable again if they were disabled
                        searchFilterContainer.removeClass("disabled");
                        triggerEvent("searchJSON_done");
                    }
                }
            };
        }
    });
});

